import React, { useEffect, useRef, useState } from "react";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import "../../../libs/css/bootstrap.min3.3.7.css";
import "../../../libs/css/sweetalert2.min.css";
import { API_ROUTES } from "../../../utils/constants";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import SubscriptionMetricChart from "./SubscriptionMetricChart";

const networkData = [
  { id: "1", name: "MTN" },
  { id: "2", name: "GLO" },
  { id: "3", name: "AIRTEL" },
  { id: "4", name: "9MOBILE" },
];

function getToday() {
  return new Date().toISOString().substr(0, 10);
}

export default function SubscriptionMetric(props) {
  const { objectToFormData, isAuthExpired, isLoading1, allCPs = [], userSessions = [] } = props;

  useEffect(() => {
    document.title = "Subscription Metric | Forthsoft";
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [isFade, setIsFade] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      fro: getToday(),
      to: getToday(),
      network_id: "",
      serviceId: "",
    },
  });

  // Service search state
  const [serviceSearch, setServiceSearch] = useState("");
  const [selectedServiceName, setSelectedServiceName] = useState("");
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const serviceDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (serviceDropdownRef.current && !serviceDropdownRef.current.contains(e.target)) {
        setShowServiceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    let services = userSessions?.filter(
      (s) =>
        s.serviceName.toLowerCase().includes(serviceSearch.toLowerCase()) ||
        s.serviceId.toLowerCase().includes(serviceSearch.toLowerCase())
    ) || [];
    if (selectedNetwork) {
      services = services.filter((s) => s.network_id == selectedNetwork);
    }
    setFilteredServices(services);
  }, [userSessions, serviceSearch, selectedNetwork]);

  const handleServiceSelect = (service) => {
    setServiceSearch(service.serviceName);
    setSelectedServiceName(service.serviceName);
    setValue("serviceId", service.serviceId);
    setShowServiceDropdown(false);
  };

  const handleServiceInputChange = (e) => {
    setServiceSearch(e.target.value);
    setShowServiceDropdown(true);
    if (e.target.value === "") {
      setSelectedServiceName("");
      setValue("serviceId", "");
    }
  };

  const getData = async (filters) => {
    setIsFade(true);
    setIsLoading(true);

    const body = {
      fro: filters.fro,
      to: filters.to,
    };
    if (filters.network_id) body.network_id = filters.network_id;
    if (filters.serviceId) body.service_id = filters.serviceId;

    try {
      const response = await fetch(API_ROUTES.CP_SUBSCRIBER_COUNTS, {
        method: "POST",
        body: objectToFormData(body),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      isAuthExpired(responseJSON);

      if (responseJSON.status.toString() === "200") {
        setRawData(responseJSON.data || []);
        setIsLoading(false);
        setIsFade(false);
        setServiceSearch("");
        setValue("serviceId", "");
      } else {
        setRawData([]);
        setChartData([]);
        setIsLoading(false);
        setIsFade(false);
        Swal.fire({
          title: "Error",
          text: responseJSON.message || "Failed to fetch subscriber counts",
          icon: "error",
        });
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setChartData([]);
      setIsLoading(false);
      setIsFade(false);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (!rawData.length) {
      setChartData([]);
      return;
    }
    const resolved = rawData.map((row) => {
      const cp = allCPs.find((c) => String(c.id) === String(row.cp_id));
      return {
        cp: cp ? cp.name : `CP ${row.cp_id}`,
        subscriber_count: Number(row.subscriber_count || 0),
      };
    });
    setChartData(resolved);
  }, [rawData, allCPs]);

  useEffect(() => {
    getData({ fro: getToday(), to: getToday(), network_id: "", serviceId: "" });
  }, []);

  return (
    <>
      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm mt--20">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid mb-90">
                  <div className="card-header mb--30 mb-xs-10 ml-10">
                    <h2>Subscription Metric</h2>
                  </div>

                  {isLoading1 ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      {/* Filter */}
                      <div className="row mb-10 mt-40">
                        <form onSubmit={handleSubmit(getData)} className="row">
                          {/* Row 1: Network + Service search */}
                          <div className="col-lg-12">
                            <div className="col-sm-3 pr-0">
                              <select
                                className="filter_text"
                                {...register("network_id")}
                                onChange={(e) => {
                                  setSelectedNetwork(e.target.value);
                                }}
                                style={{ textTransform: "capitalize" }}
                              >
                                <option value="">All Networks</option>
                                {networkData.map((n) => (
                                  <option key={n.id} value={n.id}>
                                    {n.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-sm-3 pr-0" ref={serviceDropdownRef}>
                              <div style={{ position: "relative" }}>
                                <input
                                  type="text"
                                  className="filter_text"
                                  placeholder="Search Service (optional)..."
                                  value={serviceSearch}
                                  onChange={handleServiceInputChange}
                                  onFocus={() => setShowServiceDropdown(true)}
                                  style={{ textTransform: "capitalize" }}
                                  autoComplete="off"
                                />
                                <input type="hidden" {...register("serviceId")} />
                                {showServiceDropdown && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                      right: 0,
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      backgroundColor: "white",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                      zIndex: 1000,
                                      marginTop: "2px",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    {filteredServices.length > 0 ? (
                                      filteredServices.map((service) => (
                                        <div
                                          key={service.serviceId}
                                          onClick={() => handleServiceSelect(service)}
                                          style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f0f0f0",
                                            textTransform: "capitalize",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#f5f5f5")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.backgroundColor = "white")
                                          }
                                        >
                                          {service.serviceName}
                                        </div>
                                      ))
                                    ) : (
                                      <div style={{ padding: "8px 12px", color: "#999" }}>
                                        No services found
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-sm-2 pr-0">
                              <input
                                type="date"
                                className="filter_text"
                                {...register("fro", { required: "From date is required" })}
                                max={getToday()}
                              />
                              {errors.fro && (
                                <small className="text-danger">{errors.fro.message}</small>
                              )}
                            </div>

                            <div className="col-sm-2 pr-0">
                              <input
                                type="date"
                                className="filter_text"
                                {...register("to", { required: "To date is required" })}
                                max={getToday()}
                              />
                              {errors.to && (
                                <small className="text-danger">{errors.to.message}</small>
                              )}
                            </div>

                            <div className="col-sm-2 p-0 pl-5">
                              <button
                                className="btn_1 btn-primary w-100"
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                  opacity: isSubmitting ? "0.5" : 1,
                                  minHeight: "38px",
                                }}
                              >
                                {isSubmitting ? (
                                  <>
                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>
                                    <i className="fa fa-search mr-2"></i>
                                    Filter
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div className="text-left pl-5 mt-15 mb-5 text-black d-flex gap-4">
                        {selectedServiceName && <span>Selected Service: {selectedServiceName}</span>}
                      </div>

                      <div style={{ opacity: isFade ? "0.3" : 1 }}>
                        {isLoading && <LoadingSpinner />}

                        {!isLoading && chartData.length === 0 && (
                          <div
                            className="mt-20 ml-10"
                            style={{ color: "#888", fontSize: "14px" }}
                          >
                            No data found for the selected period.
                          </div>
                        )}

                        {!isLoading && chartData.length > 0 && (
                          <SubscriptionMetricChart data={chartData} />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <Footers />
          </div>
        </div>
      </div>
    </>
  );
}
